import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { CheckCircle2, Phone, MessageCircle } from "lucide-react";
import Seo from "@/components/Seo";
import { useTr } from "@/i18n";

export default function Grazie() {
  const tr = useTr();
  return (
    <>
      <Seo
        title="Grazie! | DJ Magix"
        description="Richiesta ricevuta."
        path="/grazie"
        noindex
      />
      <section className="pt-48 pb-32 max-w-2xl mx-auto px-6 text-center" data-testid="grazie-page">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <CheckCircle2 size={56} className="mx-auto text-[#E2B857]" aria-hidden="true" />
          <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight gold-text mt-6">
            {tr("grazie.title", "Richiesta inviata!")}
          </h1>
          <p className="text-base text-[#E2C882]/85 leading-relaxed mt-4 max-w-md mx-auto">
            {tr(
              "grazie.text",
              "Grazie per avermi scritto: ti rispondo personalmente al più presto, di solito entro poche ore. Se l'evento è vicino, chiamami pure direttamente."
            )}
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
            <a
              href="tel:+41764411359"
              data-testid="grazie-call-button"
              className="gold-btn rounded-full px-8 py-3.5 text-sm font-bold uppercase tracking-[0.15em] inline-flex items-center gap-2"
            >
              <Phone size={16} /> 076 441 13 59
            </a>
            <a
              href="https://wa.me/41764411359"
              data-testid="grazie-whatsapp-button"
              className="inline-flex items-center gap-2 rounded-full gold-frame bg-black/40 px-8 py-3.5 text-sm uppercase tracking-[0.15em] text-[#F7DE8B] hover:bg-[#E2B857]/10 transition-colors"
            >
              <MessageCircle size={16} /> WhatsApp
            </a>
          </div>
          <Link
            to="/"
            data-testid="grazie-home-link"
            className="inline-block text-xs uppercase tracking-[0.25em] text-[#BFA45D] hover:text-[#F7DE8B] transition-colors mt-10"
          >
            {tr("grazie.home", "Torna alla home")}
          </Link>
        </motion.div>
      </section>
    </>
  );
}
